/* OsLinkHashRenderer.js */

"use strict";

const _ = require("lodash");

class IotOsLinkHashRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("oslink-hash-column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }
    _registerListeners() {
        this._model.on("OsLinkHash", (this._onOsLinkHash = this._onOsLinkHash.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeAllListeners("OsLinkHash");
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setOsLinkHash(this._model.getValue());
            resolve();
        });
        return prom;
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onOsLinkHash(newVal) {
        this._setOsLinkHash(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _setOsLinkHash(newVal) {
        const hashEl = document.createElement("span");
        hashEl.innerHTML = newVal?.sha1 || "";
        hashEl.title = newVal?.sha1 || "";
        this._rootElem.innerHTML = "";
        this._rootElem.appendChild(hashEl);
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = IotOsLinkHashRenderer;
